import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "../assets/styles/Address.css";

const Address = () => {
  const { cartItems, selectedItems } = useCart();
  const [formData, setFormData] = useState(() => {
    const fromPayment = sessionStorage.getItem("fromPayment");
    const savedData = localStorage.getItem("checkoutFormData");

    if (fromPayment && savedData) {
      sessionStorage.removeItem("fromPayment");
      return JSON.parse(savedData);
    }

    localStorage.removeItem("checkoutFormData");
    return {
      firstName: "",
      lastName: "",
      email: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      phoneCode: "+91",
      phoneNumber: "",
    };
  });
  const navigate = useNavigate();
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const requiredFields = [
    "firstName",
    "lastName",
    "email",
    "addressLine1",
    "city",
    "state",
    "postalCode",
    "phoneNumber",
  ];

  // Calculate total MRP (actual price)
  const totalMRP = cartItems.reduce(
    (total, item) =>
      selectedItems[item.id]
        ? total + parseInt(item.actualPrice) * item.quantity
        : total,
    0
  );

  // Calculate total selling price
  const totalSellingPrice = cartItems.reduce(
    (total, item) =>
      selectedItems[item.id]
        ? total + parseInt(item.sellingPrice) * item.quantity
        : total,
    0
  );

  // Calculate discount amount
  const discountAmount = totalMRP - totalSellingPrice;

  // Platform fee (tax) and shipping fee
  const platformFee = 0; // Replace with actual tax value if available
  const shippingFee = 0; // Your original shipping fee

  // Calculate final total
  const totalAmount = totalSellingPrice + platformFee + shippingFee;

  // Update the selectedItemsCount calculation
  const selectedItemsCount = cartItems.reduce(
    (count, item) => (selectedItems[item.id] ? count + item.quantity : count),
    0
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Add email validation if needed
    if (name === "email") {
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!isValidEmail && value !== "") {
        // You can add email validation UI feedback here
        console.log("Invalid email format");
      }
    }

    const newFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(newFormData);
    localStorage.setItem("checkoutFormData", JSON.stringify(newFormData));
  };

  const handleContinue = () => {
    if (selectedItemsCount === 0) {
      setShowErrorPopup(true);
      return;
    }

    const isValid = requiredFields.every((field) => formData[field].trim());

    if (isValid) {
      localStorage.setItem("checkoutFormData", JSON.stringify(formData));
      navigate("/checkout");
    }
  };

  useEffect(() => {
    // Check if we have saved selected items
    const selectedItems = localStorage.getItem("selectedItems");

    // If no selected items and not coming from payment page, redirect to home
    const fromPayment = sessionStorage.getItem("fromPayment");

    if (!selectedItems && !fromPayment) {
      navigate("/");
      return;
    }
  }, [navigate]);

  return (
    <div className="checkout-container">
      <div className="checkout-progress">
        <div className="progress-step active">ADDRESS</div>
        <div className="progress-separator">-------</div>
        <div className="progress-step">CHECKOUT</div>
      </div>

      <div className="checkout-content">
        <div className="checkout-addresses-section">
          <form className="checkout-address-form">
            <div className="form-row">
              <div className="form-group">
                <label>
                  FIRST NAME
                  <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  required
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>
                  LAST NAME
                  <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="lastName"
                  required
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>
                E-MAIL ID
                <span className="required">*</span>
              </label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>
                ADDRESS LINE 1<span className="required">*</span>
              </label>
              <input
                type="text"
                name="addressLine1"
                required
                value={formData.addressLine1}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>ADDRESS LINE 2</label>
              <input
                type="text"
                name="addressLine2"
                value={formData.addressLine2}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-row three-columns">
              <div className="form-group">
                <label>
                  CITY
                  <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="city"
                  required
                  value={formData.city}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>
                  STATE/PROVINCE
                  <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="state"
                  required
                  value={formData.state}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>
                  POSTAL CODE
                  <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="postalCode"
                  required
                  value={formData.postalCode}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-row four-columns">
              <div className="form-group phone-group">
                <label>
                  PHONE NUMBER
                  <span className="required">*</span>
                </label>
                <div className="phone-input">
                  <input
                    type="text"
                    name="phoneCode"
                    value={formData.phoneCode}
                    disabled
                    className="country-code"
                  />
                  <input
                    type="tel"
                    name="phoneNumber"
                    required
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                  />
                </div>
                <span className="billing-address-text">
                  Billing address will be same as shipping address
                </span>
              </div>
            </div>
          </form>
        </div>

        <div className="checkout-price-details">
          <h2>PRICE DETAILS ({selectedItemsCount} Items)</h2>
          <div className="checkout-price-breakdown">
            <div className="checkout-price-row">
              <span>Amount</span>
              <span>${totalMRP}</span>
            </div>
            <div className="checkout-price-row">
              <span>Discount Price</span>
              <span className="checkout-discount">-${discountAmount}</span>
            </div>

            <div className="checkout-price-row">
              <span>Tax</span>
              <span
                className="checkout-platform-fee"
                style={{ color: platformFee === 0 ? "#6F4685" : "#282c3f" }}
              >
                {platformFee === 0 ? "FREE" : `$${platformFee}`}
              </span>
            </div>
            <div className="checkout-price-row">
              <span>Shipping Fee</span>
              <span
                className="checkout-shipping-fee"
                style={{ color: shippingFee === 0 ? "#6F4685" : "#282c3f" }}
              >
                {shippingFee === 0 ? "FREE" : `$${shippingFee}`}
              </span>
            </div>
            <div className="checkout-price-hr">
              <hr />
            </div>
            <div className="checkout-price-row checkout-total">
              <span>Total Amount</span>
              <span>${totalAmount}</span>
            </div>
          </div>

          <button
            className="checkout-continue-btn"
            onClick={handleContinue}
            disabled={!requiredFields.every((field) => formData[field].trim())}
            style={{
              opacity: requiredFields.every((field) => formData[field].trim())
                ? 1
                : 0.5,
              cursor: requiredFields.every((field) => formData[field].trim())
                ? "pointer"
                : "not-allowed",
            }}
          >
            CONTINUE
          </button>
        </div>
      </div>

      {showErrorPopup && (
        <div className="error-popup-overlay">
          <div className="error-popup">
            <button
              className="error-close-popup"
              onClick={() => {
                setShowErrorPopup(false);
                navigate("/");
              }}
            >
              ×
            </button>
            <div className="error-popup-content">
              <div className="error-icon">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png"
                  alt="error-icon"
                  className="error-icon-img"
                />
              </div>
              <h2>Oops!</h2>
              <p className="error-message">
                Please select at least one item to proceed
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Address;
